import React from 'react';
import type { onDirtyCheckType } from '@makemydeal/dr-dash-components';
import VehicleProtectionCompact from './vehicleProtection/VehicleProtectionCompact';
import { ManualVPProvider } from './manualVppTable/VehicleProtectionManualContext';

type VehicleProtectionCompactActivityProps = {
    onDirtyCheck: onDirtyCheckType;
    shouldTriggerValidation?: boolean;
};

const VehicleProtectionCompactActivity = ({
    onDirtyCheck,
    shouldTriggerValidation = false
}: VehicleProtectionCompactActivityProps) => {
    return (
        <ManualVPProvider onDirtyCheck={onDirtyCheck} shouldTriggerValidation={shouldTriggerValidation}>
            <VehicleProtectionCompact />
        </ManualVPProvider>
    );
};

export default VehicleProtectionCompactActivity;
